import { ShipAi } from './ship-ai'
import { World } from '../../model/world'
import { GameUpdateState, GameUpdate, GameUpdateParentState, GameUpdateListState } from '../game-update'
import { EntityMotion } from '../motion/entity-motion'
import { WeaponFireStateMachine } from '../motion/weapons-fire'
import { Graphics } from 'src/app/display/graphics'
import { vector } from 'src/app/math/vector'
import { PlayerMoveState, WeaponsFireState } from './player-turn'
import { Point } from 'src/app/math/point'
import { Ship } from 'src/app/model/ship'

export class WorldTurnGameUpdate extends GameUpdateListState {
  protected readonly shipAi = new ShipAi()

  constructor() {
    super(worldTurnGameUpdateGenerator, new PlayerMoveState())
  }

  exitState(world: World): World {
    return world.endPhase()
  }
}

function worldTurnGameUpdateGenerator(world: World): GameUpdate[] {
  const world0 = world.enemies.reduce((accWorld, ship) => {
    const shipAction = this.shipAi.action(accWorld, ship)
    const destination = shipAction.move(accWorld, ship, world.ship)
    const newShip = ship.setDestination(destination)
    return accWorld.setShip(newShip)
  }, world)

  return world0.enemies.map(ship => {
    if (ship.destination !== undefined) {
      const parentState = new EntityMoveState(ship.name, ship.destination)
      return new GameUpdate(parentState)
    }
  }).flat()
}

class EntityMoveState extends GameUpdateParentState {
  constructor(readonly shipName: string, readonly destination: Point) {
    super(new EntityMotion(shipName, destination), new EntityFireState(shipName))
  }
}

class EntityFireState extends GameUpdateState {
  constructor(readonly shipName: string) { super() }

  update(world: World, elapsed: number): World {
    const ship = world.enemies.find(s => s.name === this.shipName)
    if (ship !== undefined) {

      const weapons = ship.weapons.filter(weapon => weapon.canAttack(ship, world.ship))
      if (weapons !== undefined) {
        const fireState = new WeaponsFireState(ship, world.ship, weapons)

        return this.changeState(world, fireState)
      }
    }

    this.completed(world)

    return world
  }
}
